export default (config) => {
    if (!config.headers['Cache-Control']) {
        config.headers['Cache-Control'] = 'no-cache';
    }
    return config;
};
